import { CloseOutlined } from '@ant-design/icons';
import { Modal, Form, Title, Descriptions, Text } from '@bancobarigui/barihaus';
import { useEffect } from 'react';

import { ScheduleForm } from './ScheduleForm';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';
import { InspectionRequest } from '@/services/types/inspection.types';

import { useScheduleInspectionModal } from './useScheduleInspectionModal';

interface ScheduleInspectionModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  itemId?: string;
  inspectionData?: InspectionRequest | undefined;
}

export function ScheduleInspectionModal({
  open,
  onClose,
  onSuccess,
  itemId,
  inspectionData,
}: ScheduleInspectionModalProps) {
  const { form, isSubmitting, handleFormSubmit } = useScheduleInspectionModal({
    itemId: itemId || '',
    onClose,
    onSuccess,
  });

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  if (!inspectionData || !itemId) return null;

  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('pt-BR');
  };

  return (
    <Modal
      centered
      open={open}
      width={800}
      footer={null}
      onCancel={onClose}
      className="space-y-8"
      closeIcon={<CloseOutlined />}
    >
      <div className="mb-6">
        <Title level={2}>Agendar Inspeção - #{inspectionData.proposalNumber}</Title>
      </div>

      <Descriptions
        column={{ xs: 1, sm: 2 }}
        bordered
        size="small"
        items={[
          {
            key: 'channel',
            label: <Text strong>Canal</Text>,
            children: inspectionData.channel || '-',
          },
          {
            key: 'proposalNumber',
            label: <Text strong>Nº da Proposta</Text>,
            children: inspectionData.proposalNumber || '-',
          },
          {
            key: 'createdAt',
            label: <Text strong>Solicitação</Text>,
            children: formatDate(inspectionData.createdAt),
          },
          {
            key: 'status',
            label: <Text strong>Status</Text>,
            children: inspectionData.status || '-',
            span: 2,
          },
        ]}
      />

      <div className="mt-6">
        <Title level={4}>Informações de Agendamento</Title>

        <Form form={form} layout="vertical" onFinish={handleFormSubmit} className="mt-4">
          <ScheduleForm />

          <RegisterFormButtons onClickCancel={onClose} loading={isSubmitting} />
        </Form>
      </div>
    </Modal>
  );
}
